<div class="users-page">
  <!-- Page head -->
  <div class="page-head">
    <div class="page-head-main">
      <h1 class="page-title">User management</h1>
      <div class="page-sub">
        {{ companies?.length ?? 0 }} companies · manage members and access
      </div>
    </div>
    <div class="d-flex align-items-center" style="gap: 8px">
      <button
        type="button"
        class="btn btn-ghost"
        (click)="expandAll()"
      >
        {{ allExpanded ? "Collapse" : "Expand" }} all
      </button>
      @if (!isAdmin) {
        <button
          type="button"
          class="btn btn-ghost"
          (click)="newCompany()"
        >
          + New company
        </button>
      }
      <button
        type="button"
        class="btn btn-primary"
        (click)="newUser()"
      >
        + New user
      </button>
    </div>
  </div>

  @if (companies) {
    @for (company of companies; track company.id) {
      <section class="card users-company" [class.is-open]="company.expanded">
        <button
          type="button"
          class="users-company-head"
          (click)="onRowClick(company)"
        >
          <div class="users-company-title">
            <span class="users-company-name">{{ company.name }}</span>
            <span class="users-company-count">
              {{ company.users ? company.users.length : 0 }}
              {{ (company.users?.length ?? 0) === 1 ? "user" : "users" }}
            </span>
            @if (company.id > 0 && company.expanded) {
              <span
                class="users-company-edit"
                appClickStop
                (click)="newCompany(company); $event.stopPropagation()"
                title="Edit company"
              >
                <mat-icon>edit</mat-icon>
              </span>
            }
          </div>
          <span class="users-company-toggle">
            {{ company.expanded ? "Hide" : "Show" }} details
            <mat-icon>
              {{ company.expanded ? "expand_less" : "expand_more" }}
            </mat-icon>
          </span>
        </button>

        @if (company.expanded) {
          <div class="users-company-body">
            @if (company.users && company.users.length) {
              <table class="users-table">
                <thead>
                  <tr>
                    <th class="col-actions"></th>
                    <th>Name</th>
                    <th>Position</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Last login</th>
                    <th class="num">30d</th>
                    <th class="num">1y</th>
                    <th class="center">2FA</th>
                    <th class="center">Active</th>
                  </tr>
                </thead>
                <tbody>
                  @for (user of company.users; track user.id) {
                    <tr>
                      <td class="col-actions">
                        <button
                          type="button"
                          mat-icon-button
                          class="users-row-menu"
                          [matMenuTriggerFor]="menu"
                        >
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                          <button
                            type="button"
                            mat-menu-item
                            (click)="newUser(user, company.allIndices)"
                          >
                            Edit profile
                          </button>
                          <button
                            type="button"
                            mat-menu-item
                            (click)="confirmDelete(user)"
                          >
                            Delete
                          </button>
                        </mat-menu>
                      </td>
                      <td>
                        <span class="cell-name">
                          <span
                            class="users-avatar"
                            [style.backgroundImage]="
                              'url(' + user.getPhoto() + ')'
                            "
                          ></span>
                          <span class="users-name">
                            {{ user.first_name }} {{ user.last_name }}
                          </span>
                        </span>
                      </td>
                      <td>{{ user.job_description || "—" }}</td>
                      <td>{{ user.phone || "—" }}</td>
                      <td>{{ user.email }}</td>
                      <td class="cell-date">{{ user.last_login || "—" }}</td>
                      <td class="num">{{ user.auth_logs_30_days ?? 0 }}</td>
                      <td class="num">{{ user.auth_logs_1_year ?? 0 }}</td>
                      <td class="center">
                        <mat-checkbox
                          [disabled]="true"
                          [(ngModel)]="user.two_fa_enabled"
                          [checked]="user.two_fa_enabled"
                          color="primary"
                        ></mat-checkbox>
                      </td>
                      <td class="center">
                        <mat-checkbox
                          [disabled]="true"
                          [(ngModel)]="user.activated"
                          [checked]="user.activated"
                          color="primary"
                        ></mat-checkbox>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            } @else {
              <div class="users-empty">No users in this company yet.</div>
            }
          </div>
        }
      </section>
    }
  } @else {
    <div class="card users-loading">Loading…</div>
  }
</div>
